import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Detox from "./img/Detox.jpg";
import Inpatient from "./img/Inpatient.webp";
import Personalized from "./img/Personalized.jpg";
import Family from "./img/Family.jpg";
import Aftercare from "./img/Aftercare.webp";
import Motivational from "./img/Motivational.jpeg";
import Holistic from "./img/Holistic.jpg";
// Naye images yaha import kar lena bhai
import Nutrition from "./img/Nutrition.jpg"; 
import ArtTherapy from "./img/ArtTherapy.jpg"; 

const AboutBanner = () => {
  // Ultra-smooth spring animations for luxury feel
  const fadeUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { type: "spring", stiffness: 40, damping: 20 } 
    }
  };

  return (
    <div id="ultra-luxury-about">
      <style>
        {`
          #ultra-luxury-about {
            /* Ultimate Luxury Brand Colors */
            --brand-pink: #ec1c74;
            --brand-blue: #00a8e8;
            --bg-base: #f5f5f7; /* Apple signature grey */
            --glass-bg: rgba(255, 255, 255, 0.5);
            --glass-card: rgba(255, 255, 255, 0.75);
            --glass-border: rgba(255, 255, 255, 0.6);
            --text-dark: #1d1d1f;
            --text-muted: #86868b;
            --gradient-accent: linear-gradient(135deg, var(--brand-blue) 0%, var(--brand-pink) 100%);
            
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            background-color: var(--bg-base);
            padding: 6rem 2rem;
            min-height: 100vh;
            overflow: hidden;
            box-sizing: border-box;
            position: relative;
          }

          /* Ambient Glowing Orbs in Background */
          #ultra-luxury-about::before,
          #ultra-luxury-about::after {
            content: '';
            position: absolute;
            border-radius: 50%;
            filter: blur(120px);
            z-index: 0;
            opacity: 0.4;
            animation: floatOrb 10s ease-in-out infinite alternate;
          }

          #ultra-luxury-about::before {
            width: 600px;
            height: 600px;
            background: rgba(0, 168, 232, 0.3);
            top: -10%;
            left: -10%;
          }

          #ultra-luxury-about::after {
            width: 500px;
            height: 500px;
            background: rgba(236, 28, 116, 0.25);
            bottom: 10%;
            right: -10%;
            animation-delay: -5s;
          }

          @keyframes floatOrb {
            0% { transform: translate(0, 0) scale(1); }
            100% { transform: translate(30px, 50px) scale(1.1); }
          }

          #ultra-luxury-about * {
            box-sizing: border-box;
            position: relative;
            z-index: 1;
          }

          #ultra-luxury-about .about-wrapper {
            max-width: 1300px;
            margin: 0 auto;
          }

          /* Hero Section */
          #ultra-luxury-about .hero-section {
            text-align: center;
            padding: 6rem 0 8rem 0;
          }

          #ultra-luxury-about .hero-title {
            font-size: 4.5rem;
            font-weight: 800;
            color: var(--text-dark);
            letter-spacing: -0.04em;
            line-height: 1.1;
            margin-bottom: 1.5rem;
          }

          #ultra-luxury-about .hero-title span {
            background: var(--gradient-accent);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            display: block;
            margin-top: 5px;
          }

          #ultra-luxury-about .hero-subtitle {
            font-size: 1.4rem;
            color: var(--text-muted);
            max-width: 700px;
            margin: 0 auto 3.5rem auto;
            line-height: 1.6;
            font-weight: 500;
          }

          #ultra-luxury-about .explore-btn {
            background: var(--gradient-accent);
            color: white;
            text-decoration: none;
            padding: 18px 42px;
            border-radius: 50px;
            font-size: 1.2rem;
            font-weight: 600;
            display: inline-block;
            box-shadow: 0 15px 35px rgba(0, 168, 232, 0.3);
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            border: 1px solid rgba(255, 255, 255, 0.3);
          }

          #ultra-luxury-about .explore-btn:hover {
            transform: translateY(-5px) scale(1.03);
            box-shadow: 0 25px 50px rgba(236, 28, 116, 0.4);
          }

          /* Info Split Section (About + Mission) */
          #ultra-luxury-about .info-split-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 3rem;
            margin-bottom: 8rem;
          }

          #ultra-luxury-about .info-card {
            background: var(--glass-bg);
            backdrop-filter: blur(40px);
            -webkit-backdrop-filter: blur(40px);
            border: 1px solid var(--glass-border);
            border-radius: 40px;
            padding: 4rem;
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.8);
            transition: transform 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
          }

          #ultra-luxury-about .info-card:hover {
            transform: translateY(-10px);
          }

          #ultra-luxury-about .info-card h2 {
            font-size: 2.4rem;
            font-weight: 800;
            color: var(--text-dark);
            margin-top: 0;
            margin-bottom: 1.8rem;
            letter-spacing: -0.03em;
          }

          #ultra-luxury-about .info-card p {
            font-size: 1.2rem;
            line-height: 1.8;
            color: var(--text-muted);
            margin: 0;
          }

          /* Programs Section */
          #ultra-luxury-about .programs-header {
            text-align: center;
            margin-bottom: 5rem;
          }

          #ultra-luxury-about .programs-header h2 {
            font-size: 3.2rem;
            font-weight: 800;
            color: var(--text-dark);
            letter-spacing: -0.04em;
            margin-bottom: 1.2rem;
          }

          #ultra-luxury-about .programs-header p {
            font-size: 1.25rem;
            color: var(--text-muted);
            max-width: 800px;
            margin: 0 auto;
            line-height: 1.7;
          }

          /* Ultimate 3x3 Bento Grid for Programs */
          #ultra-luxury-about .program-card-wrapper {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
            gap: 2.5rem;
          }

          #ultra-luxury-about .program-card {
            background: var(--glass-card);
            backdrop-filter: blur(30px);
            -webkit-backdrop-filter: blur(30px);
            border: 1px solid var(--glass-border);
            border-radius: 32px;
            overflow: hidden;
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.04);
            transition: all 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
            display: flex;
            flex-direction: column;
          }

          #ultra-luxury-about .program-card:hover {
            transform: translateY(-12px);
            box-shadow: 0 35px 70px rgba(0, 168, 232, 0.12);
            border-color: rgba(236, 28, 116, 0.3);
            background: #ffffff;
          }

          #ultra-luxury-about .img-box {
            width: 100%;
            height: 250px;
            overflow: hidden;
            position: relative;
          }

          /* Gradient fade over image for seamless blending */
          #ultra-luxury-about .img-box::after {
            content: '';
            position: absolute;
            bottom: 0; left: 0; right: 0;
            height: 40%;
            background: linear-gradient(to top, var(--glass-card), transparent);
            transition: all 0.5s ease;
          }

          #ultra-luxury-about .program-card:hover .img-box::after {
            background: linear-gradient(to top, #ffffff, transparent);
          }

          #ultra-luxury-about .img-box img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
          }

          #ultra-luxury-about .program-card:hover .img-box img {
            transform: scale(1.08);
          }

          #ultra-luxury-about .program-content {
            padding: 1rem 2.5rem 2.5rem 2.5rem;
            flex-grow: 1;
            display: flex;
            flex-direction: column;
          }

          #ultra-luxury-about .program-card h3 {
            font-size: 1.5rem;
            font-weight: 700;
            color: var(--text-dark);
            margin: 0 0 12px 0;
            letter-spacing: -0.01em;
          }

          #ultra-luxury-about .program-card p {
            font-size: 1.1rem;
            color: var(--text-muted);
            line-height: 1.6;
            margin: 0;
          }

          /* Responsive Tweaks */
          @media (max-width: 1024px) {
            #ultra-luxury-about .info-split-grid {
              grid-template-columns: 1fr;
              gap: 2rem;
            }
            #ultra-luxury-about .hero-title { font-size: 3.8rem; }
          }

          @media (max-width: 768px) {
            #ultra-luxury-about { padding: 4rem 1.5rem; }
            #ultra-luxury-about .info-card { padding: 3rem 2rem; }
            #ultra-luxury-about .hero-title { font-size: 3rem; }
            #ultra-luxury-about .hero-subtitle { font-size: 1.2rem; }
            #ultra-luxury-about .programs-header h2 { font-size: 2.5rem; }
            #ultra-luxury-about .program-card-wrapper { grid-template-columns: 1fr; }
          }
        `}
      </style>

      <div className="about-wrapper">
        
        {/* Hero Section */}
        <motion.div 
          className="hero-section"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          variants={fadeUpVariant}
        >
          <h1 className="hero-title">Welcome to <span>Maa Sadhana Foundation Wellness Center</span></h1>
          <p className="hero-subtitle">Step into a world of profound healing. We help you start a new, completely healthy, and perfectly balanced life.</p>
          <Link to="/our-treatment-facility" className="explore-btn">
            Explore Wellness Programs
          </Link>
        </motion.div>

        {/* About & Mission Split Section */}
        <div className="info-split-grid">
          <motion.div 
            className="info-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: { opacity: 0, x: -50 },
              visible: { opacity: 1, x: 0, transition: { type: "spring", stiffness: 40, damping: 20 } }
            }}
          >
            <h2>About Us</h2>
            <p>
              <strong>Maa Sadhana Foundation</strong> is dedicated to providing compassionate and ultra-premium holistic care. Our team of world-class counselors, doctors, and specialists understand the delicate nuances of the wellness journey, passionately committing to guiding you towards a deeply fulfilling lifestyle.
            </p>
          </motion.div>

          <motion.div 
            className="info-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: { opacity: 0, x: 50 },
              visible: { opacity: 1, x: 0, transition: { type: "spring", stiffness: 40, damping: 20, delay: 0.1 } }
            }}
          >
            <h2>Our Vision</h2>
            <p>
              We aim to create a profoundly supportive sanctuary that empowers individuals to achieve complete, absolute wellness. We envision a space where supreme mental peace, physical vitality, and unparalleled quality of care lead you to a beautifully balanced life.
            </p>
          </motion.div>
        </div>

        {/* Programs Section */}
        <section className="programs-section">
          <motion.div 
            className="programs-header"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeUpVariant}
          >
            <h2>Our Wellness Programs</h2>
            <p>
              Discover our bespoke wellness programs tailored to your exact needs. From holistic cleansing to artistic healing, every program is a step toward profound rejuvenation.
            </p>
          </motion.div>

          <motion.div 
            className="program-card-wrapper"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={{
              hidden: { opacity: 0 },
              visible: { 
                opacity: 1, 
                transition: { staggerChildren: 0.12 } 
              }
            }}
          >
            {/* Card 1 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Detox} alt="Detox Program" loading="lazy" /></div>
              <div className="program-content">
                <h3>Holistic Cleansing</h3>
                <p>A medically supervised cleansing program to safely manage physical dependencies and elegantly prepare your body for a healthier life.</p>
              </div>
            </motion.div>

            {/* Card 2 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Inpatient} alt="Inpatient Care" loading="lazy" /></div>
              <div className="program-content">
                <h3>Residential Care</h3>
                <p>Experience 24/7 premium support with highly structured routines, private therapy, and groups in a luxuriously peaceful environment.</p>
              </div>
            </motion.div>

            {/* Card 3 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Personalized} alt="Counseling Services" loading="lazy" /></div>
              <div className="program-content">
                <h3>Personalized Counseling</h3>
                <p>Exclusive one-on-one sessions with elite expert counselors to thoughtfully address the emotional aspects of your well-being.</p>
              </div>
            </motion.div>

            {/* Card 4 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Family} alt="Family Therapy" loading="lazy" /></div>
              <div className="program-content">
                <h3>Family Therapy</h3>
                <p>Comprehensive support for your loved ones, deeply fostering mutual understanding and a positive, healing environment at home.</p>
              </div>
            </motion.div>

            {/* Card 5 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Aftercare} alt="Aftercare Support" loading="lazy" /></div>
              <div className="program-content">
                <h3>Continuous Support</h3>
                <p>Our commitment doesn't end. We provide elite continued guidance and rich resources post-treatment to seamlessly maintain long-term balance.</p>
              </div>
            </motion.div>

            {/* Card 6 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Motivational} alt="Motivational Programs" loading="lazy" /></div>
              <div className="program-content">
                <h3>Motivational Programs</h3>
                <p>Inspiring programs designed to rebuild self-esteem, boost supreme confidence, and reinforce your commitment to a healthy life.</p>
              </div>
            </motion.div>

            {/* Card 7 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Holistic} alt="Holistic Therapy" loading="lazy" /></div>
              <div className="program-content">
                <h3>Holistic Therapy</h3>
                <p>A beautiful incorporation of daily yoga, deep meditation, and mindfulness to flawlessly promote physical and mental healing.</p>
              </div>
            </motion.div>

            {/* NEW Card 8 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={Nutrition} alt="Nutritional Wellness" loading="lazy" /></div>
              <div className="program-content">
                <h3>Nutritional Wellness</h3>
                <p>Customized, gourmet diet and nutrition plans crafted by wellness experts to nourish your body and accelerate the healing process.</p>
              </div>
            </motion.div>

            {/* NEW Card 9 */}
            <motion.div className="program-card" variants={fadeUpVariant}>
              <div className="img-box"><img src={ArtTherapy} alt="Art & Music Therapy" loading="lazy" /></div>
              <div className="program-content">
                <h3>Art & Music Therapy</h3>
                <p>Creative expression therapies specifically designed to release emotional blockages and deeply foster psychological peace.</p>
              </div>
            </motion.div>

          </motion.div>
        </section>

      </div>
    </div>
  );
};

export default AboutBanner;